import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getAbsoluteLink } from '../../helpers/utils'

const StyledImage = styled.img(({ style }) => style)

const vStyle = {
  v2: {
    width: '250px',
    height: '84px',
    margin: '60px 0'
  },
  v3: {
    width: '250px',
    height: '84px',
    margin: '60px 0'
  },
  v4: { margin: '50px 0' }
}

const FooterLogo = ({ logo, version, ...rest }) => {
  return (
    <div className="row one-column">
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
        <div className="footer-logo">
          <StyledImage
            alt="Logo"
            title="Logo"
            className="img-resposive"
            src={getAbsoluteLink(logo, version)}
            style={vStyle[version]}
            {...rest}
          />
        </div>
      </div>
    </div>
  )
}

FooterLogo.propTypes = {
  logo: PropTypes.string.isRequired,
  version: PropTypes.string
}

export default FooterLogo



// WEBPACK FOOTER //
// ./src/components/Footer/FooterLogo.js